module.exports = "<div class=\"member-inner\">\n  <div class=\"member-inner-content\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"